import { UserForm } from "@/components/pages/users/components/UserForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHotels } from "@/components/pages/hotels/hooks/useHotels";
import { SuperAdminUserCreatePage } from "@/components/pages/users/SuperAdminUserCreatePage";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { PlatformRole } from "@/utils/accessControl";

export const UserCreatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userProfile, isLoading } = useAuthenticatedUser();
  const tenantId = searchParams.get("tenantId") || undefined;
  const backTo = searchParams.get("backTo") || "/users";
  const isSuperAdmin = userProfile?.role === PlatformRole.SUPER_ADMIN;

  const onUserFormBack = useCallback(
    () => navigate(backTo),
    [backTo, navigate],
  );

  const { data: hotelsResponse } = useHotels(
    { tenantId },
    !isLoading && !isSuperAdmin,
  );
  const hotels = hotelsResponse?.data || [];

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  if (isSuperAdmin) {
    return <SuperAdminUserCreatePage backTo={backTo} />;
  }

  return (
    <UserForm
      isCreating={true}
      hotels={hotels}
      onBack={onUserFormBack}
      tenantId={tenantId}
    />
  );
};
